import { Box } from '@chakra-ui/react';
import Loading from '@components/Loading';
import PaginationRouterContainer from '@components/PaginationRouterContainer';

import { useMyDispositionsContext } from '../context';
import CustomerCard from './CustomerCard';

const List = () => {
  const {
    myDispositionsList,
    totalPages,
    loading,
  } = useMyDispositionsContext();

  if (loading && myDispositionsList.length === 0) return <Loading />;

  if (!loading && myDispositionsList.length === 0) {
    return (
      <Box textAlign="center" mt={20} color="gray.500">
        Nenhum atendimento encontrado.
      </Box>
    );
  }

  return (
    <Box opacity={loading ? 0.5 : 1} transition="opacity 0.15s ease">
      <PaginationRouterContainer
        total={totalPages}
      >
        {myDispositionsList.map((disposition) => (
          <CustomerCard
            key={disposition.id}
            disposition={disposition}
          />
        ))}
      </PaginationRouterContainer>
    </Box>
  );
};

export default List;
